// Constants for the Email / Form Templates page — what's left of
// automationConstants.js after the Automation module was removed.

export const TEMPLATE_KINDS = [
  { v: "email", l: "Email Template" },
  { v: "form", l: "Form Template" },
];

// Merge-field tokens available in template bodies.
export const MERGE_FIELDS = {
  employee: [
    "employee_id", "name", "first_name", "last_name", "salutation", "designation",
    "email", "department_name", "office_name", "company_name", "role_name",
    "manager_name", "join_date", "employee_type", "work_mode",
  ],
  leave_request: ["employee_id", "name", "email", "leave_type", "days", "start_date", "end_date", "manager_name"],
  asset_request: ["employee_id", "name", "email", "category_code", "manager_name"],
  training_review: ["employee_id", "name", "email", "task_name", "assigned_to_name", "assigned_to_email", "due_date", "status", "priority", "manager_name"],
  probation_evaluation: ["employee_id", "name", "email", "designation", "department_name", "office_name", "manager_name", "manager_email", "status", "review_status"],
  appraisal: ["employee_id", "name", "email", "department_name", "office_name", "manager_name", "manager_email", "display_status"],
};
